import { useState } from 'react';
import { PageHeader } from 'ui/pageHeader';
import { SecondaryButton, BUTTON_SIZES } from 'ui/button';
import { H4, Body2, Subtitle2 } from 'ui/theme';
import { AuthenticationQueryContextProvider, useAuthenticationQueryContext } from '../contexts';
import { authMethodsText } from '../utils';
import { Section, LeftDiv, RightDiv, AuthPolicyContent } from './AuthenticationPolicyPage.styled';
import { AuthenticationPolicyForm } from './AuthenticationPolicyForm';
import { Loadable } from './Loadable';
import { SamlJsonBuilder } from './SamlJsonBuilder';

const AuthenticationPolicy = () => {
  const { isLoading, googleAuthEnabled, samlAuthEnabled, userPassAuthEnabled } =
    useAuthenticationQueryContext();

  const [isEditingAuthPolicy, setIsEditingAuthPolicy] = useState(false);

  const authText = authMethodsText({ googleAuthEnabled, samlAuthEnabled, userPassAuthEnabled });

  return (
    <>
      <PageHeader>Authentication</PageHeader>

      <Section>
        <LeftDiv>
          <H4>Authentication policy</H4>
          <Body2>Configure how your organization’s members sign in to Iterable.</Body2>
        </LeftDiv>
        <RightDiv>
          <Loadable isLoading={isLoading} height={44}>
            {isEditingAuthPolicy ? (
              <AuthenticationPolicyForm onCancel={() => setIsEditingAuthPolicy(false)} />
            ) : (
              <AuthPolicyContent>
                <div>
                  <Subtitle2>Authentication methods</Subtitle2>
                  <Body2>{authText}</Body2>
                </div>
                <SecondaryButton
                  size={BUTTON_SIZES.LARGE}
                  onClick={() => setIsEditingAuthPolicy(true)}
                >
                  Edit policy
                </SecondaryButton>
              </AuthPolicyContent>
            )}
          </Loadable>
        </RightDiv>
      </Section>

      <Section>
        <LeftDiv>
          <H4>SAML JSON builder</H4>
          <Body2>
            If you are using or plan to use SAML, use this tool to configure permissions, project
            access and roles for your identity provider.
          </Body2>
        </LeftDiv>
        <RightDiv>
          <Loadable height={200} isLoading={isLoading}>
            <SamlJsonBuilder />
          </Loadable>
        </RightDiv>
      </Section>
    </>
  );
};

export const AuthenticationPolicyPage = () => (
  <AuthenticationQueryContextProvider>
    <AuthenticationPolicy />
  </AuthenticationQueryContextProvider>
);
